export const T = {
  en_GB: {
    reasonPlanEmpty: "no product lines",
    reasonPlanExpired: "expired — set up a new agreement instead",
    reasonUnrecognizedIsin: (isin: string) => `${isin} is not in the flow's collection`,
    reasonMissingUnits: (isin: string) => `${isin} synced without units`,
    reasonPlanDuplicateIsin: (isin: string) => `${isin} appears on more than one line`,
    reasonGeneric: "not eligible",
  },
  nb_NO: {
    reasonPlanEmpty: "ingen produktlinjer",
    reasonPlanExpired: "utløpt — opprett en ny avtale i stedet",
    reasonUnrecognizedIsin: (isin: string) => `${isin} finnes ikke i flytens samling`,
    reasonMissingUnits: (isin: string) => `${isin} synkronisert uten andeler`,
    reasonPlanDuplicateIsin: (isin: string) => `${isin} står på mer enn én linje`,
    reasonGeneric: "ikke kvalifisert",
  },
} as const;
